import React from "react";

const Footer = () => {
  return (
    <footer className="bg-primary-darker py-[24px] text-[#E6E6FA] text-sm text-center">
      adv.dishatoshniwal@gmail.com
      <br /> 2022 &copy; AROHANA LEGAL <br /> +91 99872 01019
    </footer>
  );
};

export default Footer;
